const partner = require('./includes/partner');
const history = require('./includes/history');

const aboutUs = () => {
    if ($(".about-us-page").length) {
        cores();
        partner();
        history();
        setTimeout(() => {
            aos.refresh();
        }, 300)
        commits();
        scroll();
    }
}

const cores = () => {
    const $slider = $(".core-list .slide")
    $slider.slick({
        speed: 500,
        arrows: true,
        dots: true,
        nextArrow: $(".core-list").find(".next"),
        prevArrow: $(".core-list").find(".prev"),
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    autoplay: false,
                    arrows: false,
                    dots: false
                }
            },
        ]
    })
    .on("init", function () {
        aos.refresh(); //tính toán lại tọa độ các animation
    })
}

const commits = () => {
    // console.log("vao...")
    const $parent = $(".commits");
    $parent.on("mouseenter", ".commit-item", function () {
        if ($(this).hasClass("active")) return;

        let $oldItem = $parent.find(".commit-item.active")

        const handleMobile = () => {
            $oldItem.removeClass("active").find(".description").slideUp(400, () => {
                //$oldItem.removeClass("active")
            });
            $(this).addClass("active");
            $(this).find(".description").slideDown(400)
        }
        const handleDesktop = () => {
            $parent.find(".description").fadeOut(0, () => {
                $oldItem.removeClass("active")
            });
            $(this).addClass("active");
            $(this).find(".description").fadeIn(0)
            // setTimeout(() => {
                
            // }, 400)
        }

        if ($(window).width() < 992) handleMobile()
        else handleDesktop()
    });
    //init
    $parent.find(".commit-item").first().trigger("mouseenter")
}

const scroll = () => {
    let searchParams = new URLSearchParams(window.location.search)
    let hash = searchParams.get('hash')
    // console.log("hash", hash)
    if(['our-history', 'core-values', 'vision-and-mission', 'commitments'].includes(hash)) {
        $('html,body').animate({
            scrollTop: $(`#${hash}`).offset().top - 80
        }, 1000);
    }
}
module.exports = aboutUs
